const devConfig = {
    host: process.env.REACT_APP_HOST,
    baseUrl: "/api"
    // host: "http://127.0.0.1:8000/api/",
    // baseUrl: ""
};

export default devConfig;